import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Tdata from "./Tdata";

const TopCart = () => {
	const settings = {
		dots: false,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
	};
	return (
		<>
			<Slider {...settings}>
				{Tdata.map((value, index) => {
					return (
						<>
							<div className="box product" key={index}>
								<div className="nametop d_flex">
									<span className="tleft">{value.para}</span>
								</div>
								<div className="img">
									<img style={{ width: "100%", height: "220px" }} src={value.cover} alt="" />
								</div>
							</div>
						</>
					);
				})}
			</Slider>
		</>
	);
};

export default TopCart;
